import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignOffReportModel } from '../model/SignOffReportModel';
import { FileResponseModel } from '../model/FileResponseModel';

@Injectable({
  providedIn: 'root'
})
export class SignOffReportService {
   
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }
  
  fetchFilterList(page: number, size: number, filterText: string) {
    let reqParams = `?page=${page}&size=${size}` + (filterText ? `&filterText=${filterText}` : '');
    return this.httpClient.get<Page<SignOffReportModel>>(ApiUrls.signOffReportListUrl + reqParams);
  }

  initForm() {
    return this.httpClient.get<{reportTypes: string[], status: string, errorMessage: string}>(ApiUrls.initSignedOffUrl);
  }

  checkStatus(key: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.checkStatusUrl.replace('{key}', key.toString()));
  }

  createRequest(reportType: string, data: {
    reportName: string,
    base64File: string | ArrayBuffer,
    list: {
      signerName: string,
      signerMailId: string,
      xcoord: string,
      ycoord: string
    }[]
  }) {
    return this.httpClient.post<{status: string, errorMessage: string}>(
      ApiUrls.createRquestSigneOffUrl.replace('{reportType}', reportType.toString()), data);
  }

  downloadSignedOff(key: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.downloadSignedOffUrl.replace('{key}', key.toString()));
  }

  downloadSignedOffAuditTrail(key: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.downloadSignedOffAuditTrailUrl.replace('{key}', key.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
